module.exports = __webpack_public_path__ + "img/gnu_detail.c46ca2c2.jpg";